import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from "react-router-dom";
import { Navigate  } from 'react-router-dom';
import React, { Component } from "react";
import Layouthead from "./components/MasterLayout";

import UserLogin from "./components/userlogin";
import UserChangePassword from "./components/UserChangePassword";
import User from "./components/User";
import Logout from "./components/Logout";
import Expensesandservices from "./components/Expensesandservices";
import Vendorandcontract from "./components/Vendorandcontract";
import Wages from "./components/Wages";

import Materials from "./components/Materials";
import OperationalParameters from "./components/OperationalParameters";
import Projects from "./components/Projects";
import AddProject from "./components/AddProject";
import CustomerPayment from "./components/Payment";
import PaymentTransactions from "./components/PaymentTransactions";
import ContractCostMap from "./components/ContractCostMap"; 

import WagesReport from "./components/WagesReport"; 
import MaterialPurchaseReport from "./components/MaterialPurchaseReport";
import ExpensesReport from "./components/ExpensesReport";

import MaterialAmountEntry from "./components/MaterialProcurementAmountEntry";

import MaterialProcurement from "./components/MaterialProcurement";
import Projectpaymentduereport from "./components/Projectpaymentduereport";
import ProjectLedgerReport from "./components/ProjectLedgerReport";

import ProfitableReport from "./components/ProfitableReport";
import MaterialPaidAmountReport from "./components/MaterialPaidAmountReport";

import VendorPaymentsReport from "./components/VendorPaymentsReport";
import PaymentOutReport from "./components/PaymentOutReport";
import Dashboard from "./components/Dashboard";

import Transactions from "./components/Transactions";

import TransactionReport from "./components/TransactionReport";


import Projectwisedetailes from "./components/Projectwisedetailes";
import Expensedisplay from "./components/Expensedisplay";
import Expenseform from "./components/ExpenseForm";
import Importdata from "./components/importdata";

import TransactionsInsertForm from "./components/TransactionsInsertForm";

import Wagecategory from "./components/Wagecategory";

import VendorProjectPendingPaymentReport from "./components/VendorProjectPendingPaymentReport";

import VendorLedgerReport from "./components/VendorLedgerReport";
import Projectmaterialentry from "./components/Project-material-entry";
import Projectwisematerials from "./components/Projectwise-materials";

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';

import theme from './components/theme';  


class App extends Component {
	
		 constructor(props) {
    super(props);
   
     this.state = {name:'',wrap:false}
     }
 handleCallback = (childData) => {
        // Update the name in the component's state
	
        this.setState({ name: childData})
	
    }
render() {
    return ( 
	 <ThemeProvider theme={theme}>  
      <CssBaseline />  

<Router basename="/">
     

        <Routes>
		
		
		<Route path="/UserLogin" element={<UserLogin />} />
			<Route exact path="/"  element={<Navigate to="/UserLogin" />}  />
       

      <Route element={<Layouthead heading={this.state.name}/>}>  

          {/* CHANGE PASSWORD */}
	 <Route path="/Expensedisplay" element={<Expensedisplay parentsCallback={this.handleCallback}/>} /> 	  
 <Route path="/Expenseform" element={<Expenseform parentsCallback={this.handleCallback}/>} />  
		 
 <Route path="/Projectwise-materials" element={<Projectwisematerials parentsCallback={this.handleCallback}/>} /> 	  
 <Route path="/Project-material-entry" element={<Projectmaterialentry parentsCallback={this.handleCallback}/>} /> 		 
          <Route path="/change-password" element={<UserChangePassword parentsCallback={this.handleCallback}/>} />
		  
		        <Route path="/wagecategory" element={<Wagecategory parentsCallback={this.handleCallback}/>} />
			    <Route path="/User" element={<User parentsCallback={this.handleCallback}/>} />	
				
				 <Route path="/Expensesandservices" element={<Expensesandservices parentsCallback={this.handleCallback}/>} />	
		 <Route path="/Vendorandcontract" element={<Vendorandcontract parentsCallback={this.handleCallback}/>} />	
		  	 	
 <Route path="/Wages" element={<Wages parentsCallback={this.handleCallback}/>} />
 <Route path="/Materials" element={<Materials parentsCallback={this.handleCallback}/>} />
 <Route path="/OperationalParameters" element={<OperationalParameters parentsCallback={this.handleCallback}/>} />
  <Route path="/Projects" element={<Projects parentsCallback={this.handleCallback}/>} />
    <Route path="/addnewproject" element={<AddProject parentsCallback={this.handleCallback}/>} />
		  <Route path="/addnewproject/:id" element={<AddProject parentsCallback={this.handleCallback}/>} />
		  <Route path="/CustomerPayment" element={<CustomerPayment parentsCallback={this.handleCallback}/>} />
<Route path="/PaymentTransactions" element={<PaymentTransactions parentsCallback={this.handleCallback}/>} />
		  
		    <Route path="/Contractcostmap"element={<ContractCostMap parentsCallback={this.handleCallback}/>} />
		   {/* Payment Management */}
    
		<Route path="/WagesReport" element={<WagesReport parentsCallback={this.handleCallback}/>} />  
		  	  <Route path="/MaterialPurchase-report" element={<MaterialPurchaseReport parentsCallback={this.handleCallback}/>} />
		    <Route path="/Material-procurement" element={<MaterialProcurement parentsCallback={this.handleCallback}/>} />
		    <Route path="/MaterialAmountEntry" element={<MaterialAmountEntry parentsCallback={this.handleCallback}/>} />
		  
		   <Route path="/Projectpaymentduereport" element={<Projectpaymentduereport parentsCallback={this.handleCallback}/>} />
	
	<Route path="/ProjectLedgerReport" element={<ProjectLedgerReport parentsCallback={this.handleCallback}/>} />
	
	<Route path="/ProfitableReport" element={<ProfitableReport parentsCallback={this.handleCallback}/>} />
	      <Route path="/transactions" element={<Transactions parentsCallback={this.handleCallback}/>} />
		  
		    <Route path="/Expense-report" element={<ExpensesReport parentsCallback={this.handleCallback}/>} />
			
			        <Route path="/PendingPayments" element={<VendorProjectPendingPaymentReport parentsCallback={this.handleCallback}/>} />
		  <Route path="/PaymentOutReport" element={<PaymentOutReport parentsCallback={this.handleCallback}/>} />
		 
    <Route path="/vendorledgerreport" element={<VendorLedgerReport parentsCallback={this.handleCallback}/>} />
	    <Route path="/Dashboard" element={<Dashboard parentsCallback={this.handleCallback}/>} />
	
	 <Route path="/Projectwisedetailes" element={<Projectwisedetailes parentsCallback={this.handleCallback}/>} />
		 </Route>
		  
		    {/* CONTRACT COST MAP  */}
		  
		 
		   
		   {/* LABOR EXPENSES REPORT */}
		
		  
		  {/* Material Purchase REPORT */}
	
		  
		   {/* Material procurement display */}
		
		  
		   {/* Material Zero Amount Update */}
		
		  
		   {/* Material Paid Amount */}
		  <Route path="/getmaterialpaidamount" element={<MaterialPaidAmountReport />} />
		  
		    {/* VENDOR PAYMENTS */}
          <Route path="/vendorpayments" element={<VendorPaymentsReport />} />
		    {/* Payment */}
        
		  
		  {/* transactions */}
    
		  
		  {/* transactions report */}
          <Route path="/transactionreport" element={<TransactionReport />} />
		  
		    <Route path="/Importdata" element={<Importdata />} />
		    {/* Payment Management */}
          

		  {/* Project Management */}
<Route path="/Logout" element={<Logout />} />
		  
		  {/* VendorProjectPendingPaymentReport  */}
  
		  
		  {/* vendorledger report */}
{/* admincms */}
          
		  
		  
        </Routes>
		
		


    </Router></ThemeProvider>

    );
  }
}


export default App;